import { UPDATE_STATS, UPDATE_GRAPH_STATS } from './types';
import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';

const dentalCorpBackend = getDentalCorpBackend();

export const getStats = (groupId) => {
	return async (dispatch, getState) => {
		let stats = await dentalCorpBackend.getStats(getState(), groupId, dispatch);
		if (stats !== null && stats !== undefined) {
			dispatch({ type: UPDATE_STATS, payload: stats.response });
		}
	};
};

export const getSalesSummary = (groupId, durationType, startDate, endDate) => {
	return async (dispatch, getState) => {
		let stats = await dentalCorpBackend.getSalesSummary(getState(), groupId, durationType, startDate, endDate, dispatch);
		if (stats !== null && stats !== undefined) {
			dispatch({ type: UPDATE_GRAPH_STATS, payload: stats.response });
			return true;
		} else {
			return false;
		}
	};
};

export const getDSOList = () => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.getDSOList(getState(), dispatch);
		if (response !== null && response !== undefined) {
			return response.response || [];
		}
		return [];
	};
};
